<template>
  <div class='login row justify-content-md-center'>
    <div class="col-md-4" v-if="!hasLogin()">
      <h4 class="text-center mb-5">请使用用户名密码登录</h4>
      <form>
        <div class="form-group row">
          <label for="username" class="col-sm-2 col-form-label">用户名</label>
          <div class="col-sm-10">
            <input class="form-control" id="username">
          </div>
        </div>
        <div class="form-group row">
          <label for="password" class="col-sm-2 col-form-label">密码</label>
          <div class="col-sm-10">
            <input type="password" class="form-control" id="password" placeholder="">
          </div>
        </div>
        <div class="form-group row">
          <input type="submit" class="form-control btn btn-primary" value="登录" v-on:click.prevent="doLogin">
        </div>
      </form>
    </div>
    <div v-else>
      <div class="row">
        <form>
          <div class="form-group">
            <h4 class="text-center mb-5">您已经登录</h4>
            <input type="submit" class="form-control btn btn-primary" value="登出" v-on:click.prevent="doLogout">
            <input type="submit" class="form-control btn btn-primary" value="修改密码" v-on:click.prevent="$refs.passwordRef.showEditPasswordModal">
          </div>
        </form>
      </div>
      <password ref="passwordRef" v-on:doLogout="doLogout"></password>
    </div>
  </div>
</template>

<script>
import Password from '@/components/_profile/Password'
import {clearLoginCredential, hasLogin} from '@/services/auth'
import http from 'axios'

function doLogin () {
  clearLoginCredential()
  let username = document.getElementById('username').value.trim()
  let password = document.getElementById('password').value
  let data = {
    username: username,
    password: password
  }

  this.$http.post('/api/login', data).then(response => {
    if (response.data.success) {
      location.href = this.$route.query.url || '/'
    }
  })
}

function doLogout () {
  clearLoginCredential()
  http.post('/api/logout').then(response => {
    location.href = '/'
  })
}

export default {
  name: 'login',
  components: {Password},
  methods: {
    doLogin, hasLogin, doLogout
  }
}
</script>

<style lang='scss' scoped>
.login {
  margin-top: 200px;
}
</style>